// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"SocialIcons__socialIcons__1gtkW"};